import { IntegrationsPortErrors } from 'modules/Integrations/domain'
import type { AnrokIntegrationConfig } from './anrok.integration.config'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

const enableAnrokIntegration = async (): Promise<{ success: boolean }> => {
  const result = await dashboardv99990101Client.putEnabledTaxIntegration({
    taxIntegrationProvider: 'ANROK'
  })
  return { success: !result.error }
}

export const anrokConfigurationMutator = async (
  data: AnrokIntegrationConfig
): Promise<{
  success: boolean
  error: IntegrationsPortErrors | null
}> => {
  if (data.apiKey) {
    const credentialsResult =
      await dashboardv99990101Client.postStoreAnrokCredentials({
        apiKey: data.apiKey
      })

    if (credentialsResult.error) {
      return { success: false, error: IntegrationsPortErrors.Other }
    }

    const enableResult = await enableAnrokIntegration()
    if (!enableResult.success) {
      return { success: false, error: IntegrationsPortErrors.Other }
    }
  }

  return { success: true, error: null }
}
